<template>
  <div class="container-fluid">
    <div
      class="row"
      v-if="procesarCargas"
      id="vista_alta_requerimientos_capacitacion_especifica"
    >
      <div class="col-12">
        <ul
          class="nav nav-tabs flex-nowrap"
          role="tablist"
          v-if="tipo == 'Empleados'"
        >
          <li role="presentation" class="nav-item text-center w-25">
            <a
              href="#step1"
              id="li_step_1"
              class="nav-link active"
              data-toggle="tab"
              aria-controls="step1"
              role="tab"
              title="Tipo de asignación"
            >
              {{
                $t(
                  "page.capacitacion_especifica.alta_requerimientos.main_tags.tag1"
                )
              }}
            </a>
          </li>
          <li role="presentation" class="nav-item text-center w-25">
            <a
              href="#step2"
              id="li_step_2"
              class="nav-link disabled"
              data-toggle="tab"
              aria-controls="step2"
              role="tab"
              title="Selecciona los Empleados"
            >
              Procesar asignaciones
            </a>
          </li>
        </ul>
        <ul
          class="nav nav-tabs flex-nowrap"
          role="tablist"
          v-if="tipo == 'Masivo'"
        >
          <li role="presentation" class="nav-item text-center w-25">
            <a
              href="#step1"
              id="li_step_1"
              class="nav-link active"
              data-toggle="tab"
              aria-controls="step1"
              role="tab"
              title="Tipo de asignación"
            >
              {{
                $t(
                  "page.capacitacion_especifica.alta_requerimientos.main_tags.tag1"
                )
              }}
            </a>
          </li>
          <li role="presentation" class="nav-item text-center w-25">
            <a
              href="#step2"
              id="li_step_2"
              class="nav-link disabled"
              data-toggle="tab"
              aria-controls="step2"
              role="tab"
              title="Plantilla de archivo"
            >
              {{
                $t(
                  "page.capacitacion_especifica.alta_requerimientos.main_tags.tag5"
                )
              }}
            </a>
          </li>
          <li role="presentation" class="nav-item text-center w-25">
            <a
              href="#step3"
              id="li_step_3"
              class="nav-link disabled"
              data-toggle="tab"
              aria-controls="step3"
              role="tab"
              title="carga tu archivo"
            >
              {{
                $t(
                  "page.capacitacion_especifica.alta_requerimientos.main_tags.tag6"
                )
              }}
            </a>
          </li>
        </ul>
        <div>
          <div class="tab-content py-2">
            <div class="tab-pane active" role="tabpanel" id="step1">
              <div class="row justify-content-center mt-5 wizard-card">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="
                      btn
                      siguiente_cambiar_perfil_usuario
                      btn_blue
                      next-step
                      float-right
                    "
                    v-on:click="Siguiente_Despues_de_Elegir_El_Tipo"
                  >
                    <i class="fas fa-arrow-right"></i>
                    {{
                      $t(
                        "page.capacitacion_especifica.alta_requerimientos.tag1.siguiente_btn"
                      )
                    }}
                  </button>

                  <button
                    type="button"
                    class="
                      mr-1
                      btn
                      siguiente_cambiar_perfil_usuario
                      btn_blue
                      next-step
                    "
                    v-on:click="procesarCargas = false"
                  >
                    <i class="fas fa-arrow-left"></i>
                    {{
                      $t(
                        "page.capacitacion_especifica.alta_requerimientos.tag2.por_estructuras.anterior_btn"
                      )
                    }}
                  </button>
                </div>
                <div class="col-3 wizard-content" v-on:click="Activo_Masivo">
                  <div
                    class="choice"
                    id="choice_tipo_masivo"
                    data-toggle="wizard-radio"
                    rel="tooltip"
                    title=""
                    data-original-title="This is good if you travel alone."
                  >
                    <input
                      type="radio"
                      name="job"
                      id="tipo_por_estructura"
                      value="Design"
                    />
                    <div class="icon2 pt-1" id="icon_tipo_masivo">
                      <i
                        class="mdi mdi-cloud-upload"
                        style="font-size: 65px"
                      ></i>
                    </div>
                    <h6>
                      {{
                        $t(
                          "page.capacitacion_especifica.alta_requerimientos.tag1.title3"
                        )
                      }}
                    </h6>
                  </div>
                </div>
                <div class="col-3 wizard-content" v-on:click="Activo_Empleados">
                  <div
                    class="choice"
                    id="choice_tipo_por_puesto"
                    data-toggle="wizard-radio"
                    rel="tooltip"
                    title=""
                    data-original-title="This is good if you travel alone."
                  >
                    <input
                      type="radio"
                      name="job"
                      id="tipo_por_puestos"
                      value="Design"
                    />
                    <div class="icon2 pt-4" id="icon_tipo_por_puesto">
                      <i class="fas fa-briefcase" style="font-size: 50px"></i>
                    </div>
                    <h6>
                      {{
                        $t(
                          "page.capacitacion_especifica.alta_requerimientos.tag1.title2"
                        )
                      }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" role="tabpanel" id="step2">
              <div v-if="tipo == 'Empleados'">
                <div class="row mt-4 justify-content-end">
                  <div class="col-auto">
                    <button
                      type="button"
                      class="
                        btn
                        anterior_cambiar_perfil_usuario
                        btn_blue
                        prev-step
                      "
                      v-on:click="Anterior_Despues_de_Elegir_El_Tipo"
                    >
                      <i class="fas fa-arrow-left"></i>
                      {{
                        $t(
                          "page.capacitacion_especifica.alta_requerimientos.tag2.por_estructuras.anterior_btn"
                        )
                      }}
                    </button>
                  </div>
                  <div class="col-auto">
                    <button
                      type="button"
                      :disabled="
                        !empleadoInd || !temaInd || archivoDC3.length == 0
                      "
                      class="ml-1 btn btn-primary"
                      @click="verModalProcesar"
                    >
                      Procesar
                    </button>
                  </div>
                </div>
                <div class="row justify-content-center mt-3">
                  <div class="col-6">
                    <form>
                      <div class="form-group">
                        <label for="curpEMP">CURP</label>
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            id="curpEMP"
                            v-model="curpEmpInd"
                            @keydown.enter="buscarEmpleado()"
                            aria-describedby="curpHelp"
                          />
                          <div class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              @click="buscarEmpleado()"
                            >
                              buscar
                            </button>
                          </div>
                        </div>
                        <small id="curpEMPHelp" class="form-text text-muted"
                          >Tienes que escribir el curp del empleado
                          completo</small
                        >
                      </div>
                      <div class="container">
                        <div :class="'card' + (empleadoInd ? ' founded' : '')">
                          <div class="container">
                            <div class="row align-items-center">
                              <div class="col-auto text-center">
                                <i class="fas fa-user-circle iconUser"></i>
                              </div>
                              <div class="col cardContainerUser">
                                <div class="card-body" v-if="empleadoInd">
                                  <h4 class="card-title">
                                    {{ empleadoInd.curp }}
                                  </h4>
                                  <h5 class="card-text">
                                    {{ empleadoInd.nombre_empleado }}
                                  </h5>
                                </div>
                                <div class="card-body" v-else>
                                  <h4 class="card-title">
                                    Usuario no encontrado
                                  </h4>
                                </div>
                              </div>
                              <div class="col-auto text-end" v-if="empleadoInd">
                                <i
                                  class="fas fa-times iconDeleteUser"
                                  @click="
                                    empleadoInd = null;
                                    curpEmpInd = '';
                                  "
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="nombreTema">Tema</label>

                        <input
                          type="text"
                          class="form-control"
                          v-model="nombreTemaEmpInd"
                          id="nombreTema"
                        /><small
                          id="nombreTemaHelp"
                          class="form-text text-muted"
                          >Escribe al menos 3 caracteres para empezar a buscar
                          el tema</small
                        >
                      </div>
                      <div
                        class="containerListTemas container mb-3 mt-1"
                        v-if="temasPosibles.length > 0"
                      >
                        <ul class="list-group">
                          <li
                            v-for="(temaPosible, index) in temasPosibles"
                            :key="'temaPosible' + index"
                            class="list-group-item"
                            @click="
                              temaInd = temaPosible;
                              nombreTemaEmpInd = '';
                            "
                          >
                            {{ temaPosible.tema_institucional }}
                          </li>
                        </ul>
                      </div>
                      <div class="container">
                        <div :class="'card' + (temaInd ? ' founded' : '')">
                          <div class="container">
                            <div class="row align-items-center">
                              <div class="col-auto text-center">
                                <i class="far fa-object-group iconUser"></i>
                              </div>
                              <div class="col cardContainerUser">
                                <div
                                  class="card-body row align-items-center"
                                  v-if="temaInd"
                                >
                                  <h4 class="card-title">
                                    {{ temaInd.tema_institucional }}
                                  </h4>
                                </div>
                                <div
                                  class="card-body row align-items-center"
                                  v-else
                                >
                                  <h4 class="card-title">Tema no encontrado</h4>
                                </div>
                              </div>
                              <div class="col-auto text-end" v-if="temaInd">
                                <i
                                  class="fas fa-times iconDeleteUser"
                                  @click="temaInd = null"
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row form-group" id="timePicker">
                        <div class="form-group col-auto">
                          <label for="fecha_acreditacion"
                            >Fecha acreditacion</label
                          >
                          <b-form-datepicker
                            :max="new Date()"
                            id="fecha_acreditacion"
                            v-model="fechaRealizacion"
                          ></b-form-datepicker>
                        </div>
                        <div class="form-group col-auto">
                          <label for="fecha_acreditacion">Fecha vigencia</label>
                          <b-form-datepicker
                            id="fecha_vigencia"
                            disabled
                            v-model="fechaVigencia"
                          ></b-form-datepicker>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="input-group mb-3 col-12"
                          v-if="archivoDC3.length == 0"
                        >
                          <div class="container">
                            <div class="row">
                              <label
                                for="inputFileDC3"
                                style="text-transform: none"
                              >
                                Archivo certificación DC3
                              </label>
                            </div>
                            <div class="custom-file row">
                              <input
                                type="file"
                                @change="onFileChangeDC3"
                                class="custom-file-input"
                                id="inputFileDC3"
                                accept="application/pdf"
                              />
                              <label
                                class="custom-file-label"
                                for="inputFileDC3"
                                >Selecciona tu archivo</label
                              >
                              <small
                                id="inputFileDC3Help"
                                class="form-text text-muted"
                                >Formato permitido PDF</small
                              >
                            </div>
                          </div>
                        </div>
                        <div class="col" v-else>
                          <label
                            for="addedFileDC3"
                            style="text-transform: none"
                          >
                            Archivo certificación DC3
                          </label>
                          <div
                            class="row"
                            id="addedFileDC3"
                            v-for="(file, index) of archivoDC3"
                            :key="index + 'fileDC'"
                          >
                            <div class="col-auto pt-2 text-right form-inline">
                              <h6
                                v-for="(file, indexk) of archivoDC3"
                                :key="indexk + 'filekDC'"
                              >
                                {{ file.name }} - Size: {{ file.size }} bytes
                              </h6>
                            </div>
                            <div class="col-1 pt-2">
                              <button
                                class="btn btn-sm btn-danger"
                                @click="archivoDC3 = []"
                              >
                                x
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div v-else>
                <div class="row mt-4 justify-content-end">
                  <div class="col-auto">
                    <button
                      type="button"
                      class="
                        btn
                        anterior_cambiar_perfil_usuario
                        btn_blue
                        prev-step
                      "
                      v-on:click="Anterior_Despues_de_Elegir_El_Tipo"
                    >
                      <i class="fas fa-arrow-left"></i>
                      {{
                        $t(
                          "page.capacitacion_especifica.alta_requerimientos.tag2.por_estructuras.anterior_btn"
                        )
                      }}
                    </button>
                  </div>
                  <div class="col-auto">
                    <button
                      type="button"
                      class="
                        ml-1
                        btn
                        siguiente_cambiar_perfil_usuario
                        btn_blue
                        next-step
                      "
                      v-on:click="Siguiente_Despues_de_Elegir_El_Empleado"
                    >
                      <i class="fas fa-arrow-right"></i>
                      {{
                        $t(
                          "page.capacitacion_especifica.alta_requerimientos.tag2.por_estructuras.siguiente_btn"
                        )
                      }}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-center mt-5">
                    <a
                      v-bind:href="plantilla"
                      target="_blank"
                      class="btn btn-secondary"
                      >{{
                        $t(
                          "page.configuracion.cargas_masivas.descarga_plantilla"
                        )
                      }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" role="tabpanel" id="step3">
              <div v-if="tipo == 'Masivo'">
                <div v-if="cargando_archivo">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border m-5" role="status">
                      <span class="sr-only">{{
                        $t("page.general.cargar")
                      }}</span>
                    </div>
                  </div>
                  <div class="col-12 text-center">
                    <h5>
                      {{ $t("page.configuracion.cargas_masivas.paso") }}
                    </h5>
                  </div>
                  <div class="progress" style="height: 20px !important">
                    <div
                      class="progress-bar progress-bar-striped"
                      role="progressbar"
                      :style="{ width: avance + '%' }"
                      :aria-valuenow="avance"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <div v-else>
                  <div class="row mt-4 justify-content-end">
                    <div class="col-auto">
                      <button
                        type="button"
                        class="
                          btn
                          anterior_cambiar_perfil_usuario
                          btn_blue
                          prev-step
                        "
                        v-on:click="Anterior_Despues_de_Elegir_El_Empleado"
                      >
                        <i class="fas fa-arrow-left"></i>
                        {{
                          $t(
                            "page.capacitacion_especifica.alta_requerimientos.tag2.por_empleados.anterior_btn"
                          )
                        }}
                      </button>
                    </div>
                    <div class="col-auto" v-if="files.length > 0">
                      <button
                        class="btn btn-success btn-info-full"
                        v-on:click="ProcesarEmpleadosCalificaciones"
                      >
                        Procesar
                      </button>
                    </div>
                  </div>
                  <div class="row mt-5 justify-content-center">
                    <div class="col-6" v-if="files.length > 0">
                      <div
                        class="row justify-content-center"
                        v-for="(file, index) of files"
                        :key="index + 'file'"
                      >
                        <div class="col-auto pt-2 text-left form-inline">
                          <h6
                            v-for="(file, indexk) of files"
                            :key="indexk + 'filek'"
                          >
                            {{ file.name }} - Size: {{ file.size }} bytes
                          </h6>
                        </div>
                        <div class="col-1 pt-2">
                          <button
                            class="btn btn-sm btn-danger"
                            v-on:click="Eliminar_Archivo"
                          >
                            x
                          </button>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-12 text-center">
                          {{
                            $t(
                              "page.configuracion.cargas_masivas.cantidad_empleados"
                            )
                          }}
                          <b>{{ empleados_calificaciones.length }} </b>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 mt-3" v-else>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text"
                            id="inputGroupFileAddon01"
                            >{{
                              $t("page.configuracion.cargas_masivas.carga")
                            }}</span
                          >
                        </div>
                        <div class="custom-file">
                          <input
                            type="file"
                            v-on:change="onFileChange"
                            class="custom-file-input"
                            accept=".xls,.xlsx"
                            id="inputGroupFile01"
                            aria-describedby="inputGroupFileAddon01"
                          />
                          <label
                            class="custom-file-label"
                            for="inputGroupFile01"
                            >{{
                              $t(
                                "page.configuracion.cargas_masivas.seleccion_archivo"
                              )
                            }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="container-fluid">
        <div class="row justify-content-end">
          <div class="col-auto">
            <button
              class="btn btn-outline-primary btn-lg"
              @click="procesarCargas = true"
            >
              Cargar certificaciones
            </button>
          </div>
        </div>
        <div class="row">
          <componenttable
            :name="tablename"
            :columns="tablecolumns"
            :order="tableorder"
            :ordertype="tableorder_type"
            :url="tableurl"
            :reload="reload"
            @consultar_dc3="consultar_dc3"
            @cargar_dc3="cargar_dc3"
            @cambiar_dc3="cambiar_dc3"
          />
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalConfirmarCreacion"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalConfirmarCreacionLabel"
      aria-hidden="true"
      v-if="empleadoInd && temaInd"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalConfirmarCreacionLabel">
              Confirmar alta de requerimiento
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-auto">
                  <input
                    type="checkbox"
                    v-model="confirmacionRequerimiento"
                    true-value="1"
                    false-value="false"
                  />
                </div>
                <div
                  v-html="
                    $t(
                      'page.plan_formacion.alta_requerimientos.seguro_confirmar',
                      {
                        nombre_empleado: empleadoInd.nombre_empleado,
                        nombre_tema: temaInd.tema_institucional,
                        fecha_acreditacion: fechaRealizacion
                      }
                    )
                  "
                  class="col"
                >
                  {{
                    $t(
                      "page.plan_formacion.alta_requerimientos.seguro_confirmar",
                      {
                        nombre_empleado: empleadoInd.nombre_empleado,
                        nombre_tema: temaInd.tema_institucional,
                        fecha_acreditacion: fechaRealizacion
                      }
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              :disabled="confirmacionRequerimiento != 1"
              class="btn btn-primary"
              @click="SiProcesar()"
            >
              Procesar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalCargarDC3"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalCargarDC3Label"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="modalCargarDC3Label"
              style="text-transform: none"
            >
              Cargar certificado DC3
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="cargando_dc3_log">
              <div class="d-flex justify-content-center">
                <div class="spinner-border m-5" role="status">
                  <span class="sr-only">{{ $t("page.general.cargar") }}</span>
                </div>
              </div>
            </div>
            <div class="container-fluid" v-else>
              <div class="row">
                <div class="col">
                  <div class="container-fluid">
                    <div class="row justify-content-center">
                      <div class="col-12" v-if="archivo_carga_log.length > 0">
                        <div
                          class="row justify-content-center"
                          v-for="(file, index) of archivo_carga_log"
                          :key="index + 'file'"
                        >
                          <div class="col-auto pt-2 text-left form-inline">
                            <h6
                              v-for="(file, indexk) of archivo_carga_log"
                              :key="indexk + 'filek'"
                            >
                              {{ file.name }} - Size: {{ file.size }} bytes
                            </h6>
                          </div>
                          <div class="col-1 pt-2">
                            <button
                              class="btn btn-sm btn-danger"
                              v-on:click="Eliminar_Archivo_Carga_Log"
                            >
                              x
                            </button>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-12 text-center">
                            {{
                              $t(
                                "page.configuracion.cargas_masivas.cantidad_empleados"
                              )
                            }}
                            <b>{{ empleados_calificaciones.length }} </b>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-else>
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              id="inputGroupFileAddon01"
                              >{{
                                $t("page.configuracion.cargas_masivas.carga")
                              }}</span
                            >
                          </div>
                          <div class="custom-file">
                            <input
                              type="file"
                              v-on:change="onFileChange_Carga_Log"
                              class="custom-file-input"
                              accept=".pdf"
                              id="inputGroupFile01"
                              aria-describedby="inputGroupFileAddon01"
                            />
                            <label
                              class="custom-file-label"
                              for="inputGroupFile01"
                              >{{
                                $t(
                                  "page.configuracion.cargas_masivas.seleccion_archivo"
                                )
                              }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalPDF"
      tabindex="-1"
      aria-labelledby="modalPDFLabel"
      aria-hidden="true"
      role="dialog"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title h4" id="modalPDFLabel">CERTIFICADO</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" v-if="fuenteIframe">
            <div class="container-fluid">
              <iframe
                :src="fuenteIframe + '#toolbar=0'"
                frameborder="0"
                id="iframeDC3"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Ventana_Confirmacion from "@/components/AppLms/Herramientas/ventana_confirmacion";
import Component_Table from "@/components/AppLms/Herramientas/table.vue";
import { storage } from "@/firebase.js";
export default {
  components: {
    ventanaconfirmacion: Ventana_Confirmacion,
    componenttable: Component_Table
  },
  data() {
    var vencimiento = new Date();
    vencimiento.setFullYear(vencimiento.getFullYear() + 2);
    const formatYmd = date => date.toISOString().slice(0, 10);
    return {
      tipo_carga: "crear",
      cargando_dc3_log: false,
      archivo_carga_log: [],
      actual_registro: null,
      procesarCargas: false,
      empleadoInd: null,
      curpEmpInd: "",
      nombreTemaEmpInd: "",
      temasPosibles: [],
      temaInd: null,
      files: [],
      tablename: "Registros de alta de empleados",
      tableorder: "fecha_alta",
      tableorder_type: "desc",
      reload: false,
      tableurl: "proveedor/log",
      fuenteIframe: "",
      tablecolumns: [
        {
          column: "",
          nomfield: "btn_drop",
          input: "dropdown",
          filter: "",
          width: 100,
          field: item => item.cve_log,
          options: [
            {
              emit: "consultar_dc3",
              text: "page.vista_proveedor.tabla_log.consultar_dc3",
              condicion: item => {
                if (item.link_dc3 && item.link_dc3 != "") return true;
                return false;
              }
            },
            {
              emit: "cambiar_dc3",
              text: "page.vista_proveedor.tabla_log.cambiar_dc3",
              condicion: item => {
                if (item.link_dc3 && item.link_dc3 != "") return true;
                return false;
              }
            },
            {
              emit: "cargar_dc3",
              text: "page.vista_proveedor.tabla_log.cargar_dc3",
              condicion: item => {
                if (item.link_dc3 && item.link_dc3 != "") return false;
                return true;
              }
            }
          ],
          texto_dropdown: "page.vista_proveedor.tabla_log.dropdownDC3"
        },
        {
          column: "page.vista_proveedor.tabla_log.certificado",
          nomfield: "certificado",
          input: "select",
          filter: "Todos",
          width: 150,
          field: item => item.certificado
        },
        {
          column: "page.vista_proveedor.tabla_log.empleado_col",
          nomfield: "curp_empleado",
          input: "text",
          filter: "",
          width: 230,
          field: item => item.curp_empleado
        },
        {
          column: "page.vista_proveedor.tabla_log.tema_col",
          nomfield: "nombre_tema",
          input: "text",
          filter: "",
          width: 280,
          field: item => item.nombre_tema
        },
        {
          column: "page.vista_proveedor.tabla_log.proveedor_col",
          nomfield: "nombre_proveedor",
          input: "",
          filter: "",
          width: 280,
          field: item => item.nombre_proveedor
        },
        {
          column: "page.vista_proveedor.tabla_log.fecha_realizacion_col",
          nomfield: "fecha_realizacion",
          input: "date",
          filter: "",
          width: 150,
          field: item => item.fecha_realizacion
        },
        {
          column: "page.vista_proveedor.tabla_log.fecha_vigencia_col",
          nomfield: "fecha_vigencia",
          input: "date",
          filter: "",
          width: 150,
          field: item => item.fecha_vigencia
        },
        {
          column: "page.vista_proveedor.tabla_log.fecha_col",
          nomfield: "fecha_alta",
          input: "date",
          filter: "",
          width: 150,
          field: item => item.fecha_alta
        }
      ],
      empleados_calificaciones: [],
      cargando_archivo: false,
      plantilla: "./static/files/Acreditaciones_Empleados.xlsx",
      question_procesar:
        "page.plan_formacion.alta_requerimientos.seguro_confirmar",
      loading: "",
      result: "d-none",
      temas_seleccionados: [],
      empleados_seleccionados: [],
      n2_array: [],
      n3_array: [],
      n4_array: [],
      n5_array: [],
      n6_array: [],
      n7_array: [],
      tipo: "Empleados",
      confirmacionRequerimiento: false,
      fechaRealizacion: formatYmd(new Date()),
      fechaVigencia: formatYmd(vencimiento),
      archivoDC3: [],
      cargandoDC3: false,
      link_dc3: ""
    };
  },
  methods: {
    cambiar_dc3(ev) {
      this.tipo_carga = "editar";
      this.actual_registro = ev;
      $("#modalCargarDC3").modal("show");
    },
    onFileChange_Carga_Log(e) {
      var that = this;
      this.cargando_dc3_log = true;
      let refStorage;
      var date = new Date();
      var timestamp = date.getTime();
      var files = e.target.files || e.dataTransfer.files;
      this.archivo_carga_log = files;
      refStorage = storage.ref(
        this.cia.firebase_storage + "/certificaciones/dc3/" + timestamp + ".pdf"
      );
      const task = refStorage.put(that.archivo_carga_log[0]);
      task.on(
        "state_changed",
        snapshot => {},
        err => {
          that.cargando_dc3_log = false;
          this.archivo_carga_log = [];
          toastr.error(
            "Hubo un problema cargando el archivo, por favor vuelve a intentarlo, si el problema persiste, comunicate con un administrador"
          );
        },
        () => {
          task.snapshot.ref
            .getDownloadURL()
            .then(async url => {
              let urlK = "proveedor/cargarDC3";
              if (that.tipo_carga == "editar") {
                urlK = "proveedor/cambiarDC3";
              }
              await this.$http
                .post(urlK, {
                  cve_log: this.actual_registro.cve_log,
                  url
                })
                .then(respuesta => {
                  return respuesta.json();
                })
                .then(respuestaJson => {
                  if (respuestaJson.resp == "Error") {
                    toastr.error(
                      "Hubo un error cargando el requerimiento, consulta al proveedor."
                    );
                  } else {
                    toastr.success("Carga de DC3 correcta.");
                    $("#modalCargarDC3").modal("hide");
                    this.reload = !this.reload;
                    this.archivo_carga_log = [];
                  }
                })
                .catch(error => {
                  toastr.clear();
                  toastr.error(
                    this.$t(
                      "page.historial_capacitacion.js_scope.prob_historial"
                    )
                  );
                  this.Listo_Modal();
                });
              that.cargando_dc3_log = false;
            })
            .catch(err => {
              console.log(err);
              that.cargando_dc3_log = false;
              this.archivo_carga_log = [];
              toastr.error(
                "Hubo un problema cargando el archivo, por favor vuelve a intentarlo, si el problema persiste, comunicate con un administrador"
              );
            })
            .finally(() => {
              this.archivo_carga_log = [];
            });
        }
      );
    },
    Eliminar_Archivo_Carga_Log() {
      this.archivo_carga_log = [];
    },
    verModalProcesar() {
      $("#modalConfirmarCreacion").modal("show");
    },
    consultar_dc3(ev) {
      $("#modalPDF").modal("show");
      this.fuenteIframe = ev.link_dc3;
    },
    cargar_dc3(ev) {
      this.actual_registro = ev;
      $("#modalCargarDC3").modal("show");
    },

    async buscarEmpleado() {
      this.$http
        .get("catalogos/empleados/getByCurpTotal/" + this.curpEmpInd)
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.empleadoInd = respuestaJson.res;
        })
        .catch(error => {
          toastr.error("Empelado no encontrado");
        });
    },

    async buscarTemas() {
      this.$http
        .post("catalogos/temas/getTemaNombre", {
          nombre_tema: this.nombreTemaEmpInd
        })
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.temasPosibles = respuestaJson.res;
        })
        .catch(error => {
          toastr.error("Tema no encontrado");
        });
    },

    async ProcesarEmpleadosCalificaciones() {
      this.cargando = true;
      let i = 0;
      let arr = this.empleados_calificaciones.slice(i, 100);
      console.log(this.empleados_calificaciones);
      let error = false;
      let errores = [];
      while (arr.length > 0) {
        i++;
        await this.$http
          .post("proveedor/alta", {
            empleados_calificaciones: arr
          })
          .then(respuesta => {
            return respuesta.json();
          })
          .then(respuestaJson => {
            if (respuestaJson.resp == "Excelente") {
              if (respuestaJson.errors && respuestaJson.errors.length > 0) {
                errores = errores.concat(respuestaJson.errors);
              }
              toastr.success(`${i} Correcta`);
            } else if (respuestaJson.errors && respuestaJson.errors.length > 0) {
              errores = errores.concat(respuestaJson.errors);
              error = true;
            } else {
              error = true;
            }
          })
          .catch(err => {
            console.log(err);
            error = true;
          });
        arr = error
          ? []
          : this.empleados_calificaciones.slice(i * 100, (i + 1) * 100);
      }
      this.cargando = false;
      const detalleErrores = this.formatErroresCalificaciones(errores);
      if (error) {
        if (errores.length == 0) {
          swal(
            "!Ups¡",
            "Hubo un problema cargando el archivo, ponte en contacto con tu proveedor. (" +
              i * 100 +
              ")",
            "error"
          );
        } else {
          swal(
            "Error en la carga",
            detalleErrores,
            "error"
          );
        }
      } else {
        if (errores.length == 0) {
          swal(
            "Excelente",
            "Las acreditaciones de los empleados fueron cargadas con exito",
            "success"
          );
          $("#modalConfirmarCreacion").modal("hide");
        } else {
          swal(
            "Cargas finalizadas",
            "Las acreditaciones de los empleados fueron cargadas con " +
              errores.length +
              " errores:\n" +
              detalleErrores,
            "info"
          );
        }
      }
    },
    formatErroresCalificaciones(errores) {
      return errores
        .map(errorItem => {
          const curp =
            errorItem.col && errorItem.col.CUIL_CUIT_CURP
              ? errorItem.col.CUIL_CUIT_CURP
              : "?";
          const mensaje =
            typeof errorItem.err === "string"
              ? errorItem.err
              : JSON.stringify(errorItem.err || errorItem);
          return `${curp}: ${mensaje}`;
        })
        .join("\n");
    },
    async onFileChangeDC3(e) {
      var that = this;
      this.cargandoDC3 = true;
      let refStorage;
      var date = new Date();
      var timestamp = date.getTime();
      var files = e.target.files || e.dataTransfer.files;
      this.archivoDC3 = files;
      refStorage = storage.ref(
        this.cia.firebase_storage + "/certificaciones/dc3/" + timestamp + ".pdf"
      );
      const task = refStorage.put(that.archivoDC3[0]);
      task.on(
        "state_changed",
        snapshot => {},
        err => {
          that.cargandoDC3 = false;
          this.archivoDC3 = [];
          toastr.error(
            "Hubo un problema cargando el archivo, por favor vuelve a intentarlo, si el problema persiste, comunicate con un administrador"
          );
        },
        () => {
          task.snapshot.ref
            .getDownloadURL()
            .then(url => {
              that.link_dc3 = url;
              that.cargandoDC3 = false;
            })
            .catch(err => {
              that.cargandoDC3 = false;
              this.archivoDC3 = [];
              toastr.error(
                "Hubo un problema cargando el archivo, por favor vuelve a intentarlo, si el problema persiste, comunicate con un administrador"
              );
            });
        }
      );
    },
    onFileChange(e) {
      var that = this;
      this.cargando_archivo = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var fileReader = new FileReader();
      fileReader.onload = function(event) {
        var data = event.target.result;
        var workbook = XLSX.read(data, {
          type: "binary"
        });
        workbook.SheetNames.forEach(sheet => {
          let rowObject = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheet],
            { raw: false }
          );

          let jsonObject = JSON.stringify(rowObject);
          that.empleados_calificaciones = JSON.parse(jsonObject);
          console.log(that.empleados_calificaciones);
          that.cargando_archivo = false;
        });
      };
      fileReader.readAsBinaryString(e.target.files[0]);
      this.files = files;
    },
    Eliminar_Archivo() {
      this.files = [];
      $("#inputGroupFile01").val("");
    },
    async validacionUsuario() {
      let that = this;
      this.temas_seleccionados.forEach(element => {
        this.$http
          .get("catalogos/temas/listar_temas/" + element.value)
          .then(async response => {
            console.log(response);
            if (response.body[0].link.includes("scorm")) {
              that.empleados_seleccionados.forEach(async element2 => {
                let formdata = new FormData();
                formdata.append("nombre_usuario", element2.cve_empleado);
                formdata.append("nombre", element2.nombre_empleado);
                formdata.append("id_tema", response.body[0].abreviatura);
                formdata.append("status", "incomplete");
                that.$http.post(
                  "plan_capacitacion/plan_formacion/alta_requerimientos/por_puestos/AltaScromUsuario",
                  formdata
                );
                formdata = new FormData();
                formdata.append("nombre_usuario", element2.cve_empleado);
                formdata.append("cve_tema", response.body[0].cve_tema);
                await this.$http.post("cursos/setPuntajeTema", formdata);
              });
            }
          });
      });
    },
    SiProcesar() {
      this.Procesar();
    },
    Activo_Masivo() {
      this.tipo = "Masivo";
      $("#icon_tipo_masivo").addClass("icon_active");
      $("#icon_tipo_por_puesto").removeClass("icon_active");
    },
    Activo_Empleados() {
      this.tipo = "Empleados";
      this.tipo_carga = "crear";
      $("#icon_tipo_masivo").removeClass("icon_active");
      $("#icon_tipo_por_puesto").addClass("icon_active");
    },
    async Procesar() {
      this.empleados_calificaciones = [];

      this.empleados_calificaciones.push({
        CUIL_CUIT_CURP: this.empleadoInd.curp,
        Fecha_Realizacion: this.fechaRealizacion.replaceAll("-", ""),
        Fecha_Vigencia: this.fechaVigencia,
        ID_TEMA: this.temaInd.cve_tema,
        link_dc3: this.link_dc3
      });

      await this.ProcesarEmpleadosCalificaciones();
      // this.Cargando();
      // this.consultando_text = "Procesando...";
      // this.$http
      //   .post(
      //     "plan_capacitacion/capacitacion_especifica/alta_requerimientos/por_empleados",
      //     {
      //       temas: this.temas_seleccionados,
      //       empleados: this.empleados_seleccionados,
      //     }
      //   )
      //   .then((respuesta) => {
      //     return respuesta.json();
      //   })
      //   .then((respuestaJson) => {
      //     if (respuestaJson.resp == "Excelente") {
      //       this.Listo();
      //       that.validacionUsuario();
      //       this.$router.push({
      //         name: "Capacitacion_Especifica_Consulta_Requerimientos",
      //       });
      //       swal(
      //         this.$t(
      //           "page.plan_formacion.alta_requerimientos.js_scope.exelente"
      //         ),
      //         this.$t(
      //           "page.plan_formacion.alta_requerimientos.js_scope.alta_req"
      //         ),
      //         "success"
      //       );
      //     } else {
      //       this.Listo();
      //       swal(
      //         "¡Ups!",
      //         this.$t(
      //           "page.plan_formacion.alta_requerimientos.js_scope.prob_alt"
      //         ),
      //         "error"
      //       );
      //     }
      //   })
      //   .catch((error) => {
      //     this.Listo();
      //     swal(
      //       "¡Ups!",
      //       this.$t(
      //         "page.plan_formacion.alta_requerimientos.js_scope.prob_alt"
      //       ),
      //       "error"
      //     );
      //   });
    },
    Siguiente_Despues_de_Elegir_El_Empleado() {
      this.nextTab();
    },
    Anterior_Despues_de_Elegir_El_Empleado() {
      this.prevTab();
    },
    Siguiente_Despues_de_Elegir_El_Tipo() {
      this.nextTab();
    },
    Anterior_Despues_de_Elegir_El_Tipo() {
      this.prevTab();
    },

    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Listo_Empleados() {
      var that = this;
      $(document).ready(function() {
        that.loading = "d-none";
        that.result = "";
        $(document).on("click", ".check_seleccionar_empleado", function(event) {
          if ($(event.currentTarget).attr("name") != undefined) {
            var cve_empleado = $(event.currentTarget).attr("name");
            var nombre_empleado = $(event.currentTarget).attr(
              "nombre_empleado"
            );
            that.empleados_seleccionados.push({
              label: nombre_empleado,
              value: cve_empleado,
              selected: true
            });
            that.Validar_Si_Hay_Empleados_Agregados();
          }
        });
      });
    },
    Listo() {
      var that = this;
      $(document).ready(function() {
        that.loading = "d-none";
        that.result = "";
      });
    },
    Consultar_Temas() {
      this.Cargando();
      this.consultando_text = "Consultando los temas...";
      this.$http
        .get(
          "plan_capacitacion/capacitacion_especifica/alta_requerimientos/por_estructuras/temas"
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.temas = respuestaJson;
        })
        .catch(error => {
          toastr.clear();
          toastr.error(
            this.$t(
              "page.plan_formacion.alta_requerimientos.js_scope.prob_temas"
            )
          );
        });
    },
    nextTab() {
      var elem = $("#vista_alta_requerimientos_capacitacion_especifica").find(
        ".nav-tabs li>.active"
      );
      elem
        .parent()
        .next()
        .find(".nav-link")
        .removeClass("disabled");
      $(elem)
        .parent()
        .next()
        .find('a[data-toggle="tab"]')
        .click();
    },
    prevTab() {
      var elem = $("#vista_alta_requerimientos_capacitacion_especifica").find(
        ".nav-tabs li>a.active"
      );
      $(elem)
        .parent()
        .prev()
        .find('a[data-toggle="tab"]')
        .click();
    },
    Definir_Buttons_Config() {
      var that = this;
      that.menu.buttons.nuevo_name = "Certificaciones externas";
      that.menu.filtros.fechas.mostrar = false;
      this.menu.buttons.excel = true;
      this.menu.buttons.imprimir = false;
      this.menu.buttons.consultar = true;
      $(document).ready(function() {
        $("#Consultar_Button").click(function() {
          that.reload = !that.reload;
        });
      });
    },
    Configurar_Steps() {
      var that = this;
      $(document).ready(function() {
        $("#vista_alta_requerimientos_capacitacion_especifica")
          .find('a[data-toggle="tab"]')
          .on("show.bs.tab", function(e) {
            var $target = $(e.target);
            if ($target.parent().hasClass("disabled")) {
              return false;
            }
          });
      });
    },
    ...mapActions([
      "Ejecutar_Tabla",
      "Actualizar_Help_Button",
      "Abrir_Ventana_Confirmacion",
      "Ejecutar_Tabla_ServerSide"
    ])
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
    cia() {
      return this.$store.getters.getCia;
    }
  },
  created() {
    this.Listo();
  },
  watch: {
    nombreTemaEmpInd(newVal) {
      if (newVal.length > 3) {
        this.buscarTemas();
      } else {
        this.temasPosibles = [];
      }
    },
    temaInd(newVal) {
      if (newVal != null) {
        console.log(newVal.meses_certificacion);
        if (newVal.meses_certificacion > 0) {
          this.fechaVigencia = new Date(this.fechaRealizacion);
          this.fechaVigencia.setMonth(
            this.fechaVigencia.getMonth() + Number(newVal.meses_certificacion)
          );
          this.fechaVigencia = this.fechaVigencia.toISOString().slice(0, 10);
        } else {
          this.fechaVigencia = new Date("9999-12-31");
        }
      }
    },
    fechaRealizacion(newVal) {
      if (this.temaInd != null) {
        if (this.temaInd.meses_certificacion > 0) {
          this.fechaVigencia = new Date(this.fechaRealizacion);
          this.fechaVigencia.setMonth(
            this.fechaVigencia.getMonth() +
              Number(this.temaInd.meses_certificacion)
          );
          this.fechaVigencia = this.fechaVigencia.toISOString().slice(0, 10);
        } else if (this.temaInd.meses_certificacion == 0) {
          this.fechaVigencia = new Date("9999-12-31");
          this.fechaVigencia = this.fechaVigencia.toISOString().slice(0, 10);
        }
      } else {
        this.fechaVigencia = new Date(this.fechaRealizacion);
        this.fechaVigencia.setFullYear(this.fechaVigencia.getFullYear() + 2);
      }
    }
  },
  updated() {},
  beforeDestroy() {
    this.menu.buttons.excel = false;
    this.menu.buttons.imprimir = false;
    this.menu.buttons.consultar = false;
  },
  mounted() {
    let that = this;
    $("#Dashboard").click(ev => {
      that.procesarCargas = false;
    });
    this.Configurar_Steps();
    this.Definir_Buttons_Config();
    this.Actualizar_Help_Button({
      mostrar: true,
      title: "Alta Requerimientos Capacitación Especifica",
      content: "Alta Requerimientos Capacitación Especifica"
    });
  }
};
</script>

<style scoped>
#timePicker /deep/ .b-calendar-inner {
  width: 100% !important;
}

#timePicker /deep/ .dropdown-menu.show {
  width: 150% !important;
}

.iconUser {
  font-size: 5em;
}
.cardContainerUser {
  text-transform: none;
}

.cardContainerUser .card-body {
  min-height: 8em;
}
.iconDeleteUser {
  font-size: 3em;
}
.containerListTemas {
  max-height: 10em;
  overflow: auto;
}
strong {
  font-weight: 900 !important;
}
#checkBoxConfirm {
  text-align: left;
  height: 2em;
  width: 1em;
}

.founded {
  border-style: solid;
  border-color: #00ab53;
  border-width: 0.3em;
  -webkit-box-shadow: 10px 8px 15px -3px #00ab53;
  box-shadow: 10px 8px 15px -3px #4e4e4e;
}
#iframeDC3 {
  width: 100%;
  height: 80vh;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Vistas_Por_Perfil/Proveedor.vue